import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=0829546e&"
import script from "./Book.vue?vue&type=script&lang=ts&"
export * from "./Book.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports